import { render, staticRenderFns } from "./RecipeContentSection.vue?vue&type=template&id=708b2fa0&scoped=true&"
import script from "./RecipeContentSection.vue?vue&type=script&lang=js&"
export * from "./RecipeContentSection.vue?vue&type=script&lang=js&"
import style0 from "./RecipeContentSection.vue?vue&type=style&index=0&id=708b2fa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b2fa0",
  null
  
)

export default component.exports